import React from 'react';
import MaterialTabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import theme from '../../../../theme';
import { useDispatch, useSelector } from 'react-redux';
import {
  ALL_TOKENS_PATH,
  NOMINATE_TOKENS_PATH,
  STAKE_TOKENS_PATH,
  STAKING_PATH,
} from '../../../../constants/router-constants';
import { setActiveTab } from '../../../../actions/staking-actions';

const StyledTabs = withStyles({
  root: {
    minHeight: 'auto',
    borderBottom: '1px solid #E3E6F7',
    width: 'calc(100% - 26px)',
    marginBottom: '32px',
  },
  indicator: {
    'display': 'flex',
    'justifyContent': 'center',
    'bottom': '0px',
    'backgroundColor': 'transparent',
    '& > span': {
      width: '100%',
      backgroundColor: theme.palette.mantra.pink,
    },
  },
  scroller: {
    overflow: 'auto !important',
  },
})((props) => <MaterialTabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles(() => ({
  root: {
    'textTransform': 'none',
    'fontWeight': '700',
    'fontSize': '18px',
    'minWidth': 'auto',
    'marginRight': '62px',
    'minHeight': 'auto',
    'paddingBottom': '8px',
    'padding': 0,
    '&:focus': {
      opacity: 1,
    },
  },
  selected: {
    color: '#ED1B6C',
  },
}))((props) => <Tab disableRipple {...props} />);

const Tabs = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const { activeTab } = useSelector((state) => state.staking);

  const setTab = (tab) => dispatch(setActiveTab(tab));

  const path = activeTab || window.location.pathname;

  let value = 0;
  if (path === ALL_TOKENS_PATH || path === STAKING_PATH) {
    value = 0;
  } else if (path === STAKE_TOKENS_PATH) {
    value = 1;
  } else if (path === NOMINATE_TOKENS_PATH) {
    value = 2;
  }

  return (
    <StyledTabs value={value}>
      <StyledTab
        label={
          <Link
            to={ALL_TOKENS_PATH}
            onClick={() => setTab(ALL_TOKENS_PATH)}
            style={{
              color: value === 0 ? '#ED1B6C' : dark ? 'white' : 'black',
              textDecoration: 'inherit',
            }}
          >
            All
          </Link>
        }
      />
      <StyledTab
        label={
          <Link
            to={STAKE_TOKENS_PATH}
            onClick={() => setTab(STAKE_TOKENS_PATH)}
            style={{
              color: value === 1 ? '#ED1B6C' : dark ? 'white' : 'black',
              textDecoration: 'inherit',
            }}
          >
            Stake
          </Link>
        }
      />
      <StyledTab
        label={
          <Link
            to={NOMINATE_TOKENS_PATH}
            onClick={() => setTab(NOMINATE_TOKENS_PATH)}
            style={{
              color: value === 2 ? '#ED1B6C' : dark ? 'white' : 'black',
              textDecoration: 'inherit',
            }}
          >
            Nominate
          </Link>
        }
      />
    </StyledTabs>
  );
};

export default Tabs;
